module.exports = __webpack_public_path__ + "img/3.0241b150.jpg";